import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.tsx';
import { demoConsoleAuth, demoConsoleData } from './data/demo-data.ts';
import { httpConsoleAuth } from './data/http-auth.ts';
import { httpConsoleData } from './data/http-data.ts';
import { applyThemeChoice, readThemeChoice } from './shell/theme.ts';
import './styles.css';

applyThemeChoice(readThemeChoice());

const demo = new URLSearchParams(window.location.search).has('demo');
const root = document.getElementById('root');
if (!root) throw new Error('missing #root element');

createRoot(root).render(
  <StrictMode>
    {demo ? (
      <App data={demoConsoleData} auth={demoConsoleAuth} />
    ) : (
      <App data={httpConsoleData} auth={httpConsoleAuth} />
    )}
  </StrictMode>,
);
